import clsx from 'clsx';

import styles from './ConfidenceBar.module.scss';

interface IConfidenceBarProps {
  confidence?: number | null;
  fade?: boolean;
  className?: string;
}

export const ConfidenceBar = ({
  confidence = 0,
  fade,
  className,
}: IConfidenceBarProps) => {
  return (
    <div className={clsx(styles.block, className)}>
      <span
        className={clsx(styles.confidencePercent, { [styles.isFaded]: fade })}
      >
        {confidence}
      </span>
      <div className={styles.bar}>
        <div
          className={clsx(styles.confidenceFill, { [styles.isFaded]: fade })}
          style={{ width: `${confidence}%` }}
        />
      </div>
    </div>
  );
};
